import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';
import {HomeLayoutComponent} from './components/layout/home-layout/home-layout.component';
import {LoginLayoutComponent} from './components/layout/login-layout/login-layout.component';
import {OnbordingLayoutComponent} from './components/layout/onbording-layout/onbording-layout.component';
import {LoginComponent} from './components/login/login.component';
import {ActivityLogComponent} from './components/my-account/activity-log/activity-log.component';
import {ChangePasswordComponent} from './components/my-account/change-password/change-password.component';
import {DeleteAccountComponent} from './components/my-account/delete-account/delete-account.component';
import {EditProfileComponent} from './components/my-account/edit-profile/edit-profile.component';
import {PrivacyPolicyComponent} from './components/privacy-policy/privacy-policy.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {SignupSubmitComponent} from './components/signup-submit/signup-submit.component';
import {TermsConditionComponent} from './components/terms-condition/terms-condition.component';
import {AuthGuardService} from './service/auth-guard.service';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CustomerRegistrationComponent } from './components/customer-registration/customer-registration.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { CreateOrderComponent } from './components/manage-orders/create-order/create-order.component';
import { ManageOrdersComponent } from './components/manage-orders/manage-orders.component';
import { ViewOrderHistoryComponent } from './components/manage-orders/view-order-history/view-order-history.component';
import { CustomerSellingCatalogComponent } from './components/customer-selling-catalog/customer-selling-catalog.component';
import { SellingCatalogDetailComponent } from './components/customer-selling-catalog/selling-catalog-detail/selling-catalog-detail.component';
import { OrderPlanningComponent } from './components/manage-orders/order-planning/order-planning.component';
import { ManageOrderListingComponent } from './components/manage-order-listing/manage-order-listing.component';
import { OrderTaskDetailComponent } from './components/manage-order-listing/order-task-detail/order-task-detail.component';
import { OrderDetailsComponent } from './components/manage-order-listing/order-details/order-details.component';



const routes: Routes = [
    {
        path: '', component: LoginLayoutComponent,
        children: [
            {path: '', component: LoginComponent},
            {path: 'forgot-password', component: ForgotPasswordComponent},
            {path: 'reset-password', component: ResetPasswordComponent},
            {path: 'signup', component: CustomerRegistrationComponent},
            {path: 'signup-submit', component: SignupSubmitComponent},
            {path: 'setpassword', component: SetPasswordComponent},
        ]
    },
   
    {
        path: '', component: HomeLayoutComponent,
        children: [
            {path: 'my-account/change-password', component: ChangePasswordComponent, canActivate: [AuthGuardService]},
            {path: 'my-account/delete-account', component: DeleteAccountComponent, canActivate: [AuthGuardService]},
            {path: 'my-account/edit-profile', component: EditProfileComponent, canActivate: [AuthGuardService]},
            {path: 'my-account/activity-log', component: ActivityLogComponent, canActivate: [AuthGuardService]},
            {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService]},
            { path: 'customer-order', component: ManageOrdersComponent,canActivate: [AuthGuardService]},
            { path: 'customer-order/add-edit-order', component: CreateOrderComponent, canActivate: [AuthGuardService] },             
            { path: 'customer-order/add-edit-order/:id', component: CreateOrderComponent, canActivate: [AuthGuardService] },   
            { path: 'customer-order/view-order-history/:id', component: ViewOrderHistoryComponent, canActivate: [AuthGuardService] },  
            { path: 'customer-order/plan-order/:id', component: OrderPlanningComponent, canActivate: [AuthGuardService]},     
    
            { path: 'selling-catalog', component: CustomerSellingCatalogComponent,canActivate: [AuthGuardService]},
            { path: 'selling-catalog/view-details/:id', component: SellingCatalogDetailComponent,canActivate: [AuthGuardService]},

            { path: 'manage-order', component: ManageOrderListingComponent,canActivate: [AuthGuardService]},
            { path: 'manage-order/view-details/:id', component: OrderDetailsComponent,canActivate: [AuthGuardService]},

        ]
    },
    {path: 'privacy-policy', component: PrivacyPolicyComponent},
    {path: 'terms-condition', component: TermsConditionComponent},
    {
        path: 'on-boarding/:id', component: OnbordingLayoutComponent,
        children: [
            {path: '', component: CustomerRegistrationComponent}
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

